import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HelpCenterArticles } from '@gelato-api-ui/core/help-center/help-center-articles';
import { PrintAreaName } from '@gelato-api-ui/core/print-areas/constants/print-area-name';

import { SanityFaqItem } from '@gelato-api-ui/core/sanity/sanity-faq-item';
import { AssetsPathPipe } from '@gelato-api-ui/sdk/src/lib/pipes/assets-path.pipe';
import { SegmentHeaderComponent } from '@gelato-api-ui/sdk/src/lib/shared/segment-header/segment-header.component';
import { SuiAccordionModule } from '@giomamaladze/ng2-semantic-ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'gd-faq-segment',
  templateUrl: './faq-segment.component.html',
  styleUrls: ['./faq-segment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SegmentHeaderComponent, NgIf, TranslateModule, SuiAccordionModule, NgForOf, AssetsPathPipe, AsyncPipe],
})
export class FaqSegmentComponent {
  @Input() items: SanityFaqItem[];
  @Input() arrowIconPath = 'dashboard/chevron-right-black.svg';
  @Input() isHelpCenterLinkVisible = true;

  helpCenterArticles = HelpCenterArticles;
  readonly PrintAreaNameEnum = PrintAreaName;

  // check if every item has text (answer)
  get isCollapsable() {
    return this.items.every(item => Boolean(item.text));
  }
}
